import { environment as env } from "../../../../../environments/environment";

const BASE_API_URL = env.ApiUrl + "api/";

export const SMS_TRAFFIC_REPORT_ENDPOINTS = {
    error_list_company:
        BASE_API_URL + "sendo-messaging/reports/sms/campaign/company/errors",
    getMetricsByCarrier: BASE_API_URL + "sendo-messaging/reports/sms/carriers",
    getsmscampaignByCompany:
        BASE_API_URL + "sendo-messaging/reports/sms/company/campaigns",
    getsmsshortcodeMetrics:
        BASE_API_URL + "sendo-messaging/reports/sms/short-codes",
};
